import { Component } from "../component"
import anime from "animejs"
import { scrollLoop } from "../helpers/scroll-loop"
import { iterable } from "../helpers/iterable"

export class Scrollspy extends Component {
  constructor(props) {
    super(props)

    this.dynamicClasses = {
      active: "-active",
    }
  }

  ui() {
    return {
      links: ".ui-scrollspy-link",
    }
  }

  handleScroll(position) {
    let activeSectionIndex = 0

    for (let i = this.sections.length - 1; i >= 0; i--) {
      if (position + window.innerHeight / 2 >= this.sections[i].offsetTop) {
        activeSectionIndex = i
        this.activateLink(activeSectionIndex)
        return
      }
    }

    this.activateLink(activeSectionIndex)
  }

  activateLink(index) {
    const { links } = this.$ui
    const { active } = this.dynamicClasses

    iterable(links).forEach((link, linkIndex) => {
      link.classList.toggle(active, index === linkIndex)
    })
  }

  getSections() {
    const { links } = this.$ui
    const sections = []

    iterable(links).forEach((link) => {
      const section = document.querySelector(link.getAttribute("href"))
      if (section) {
        sections.push(section)
      }
    })
    return sections
  }

  attachEvents() {
    const { links } = this.$ui

    iterable(links).forEach((link) => {
      link.addEventListener("click", (e) => {
        const section = document.querySelector(link.getAttribute("href"))
        if (section) {
          const position = section.offsetTop - 110
          anime({
            targets: [document.documentElement, document.body],
            scrollTop: position,
            duration: 900,
            easing: "easeInOutQuart",
          })
          e.preventDefault()
        }
      })
    })
  }

  created() {
    if (window.innerWidth >= 768) {
      this.sections = this.getSections()
      this.attachEvents()

      scrollLoop(() => {
        this.handleScroll(window.pageYOffset)
      })
    }
  }
}
